var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcForkKnifeTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 3.00156H29.5V44.9816H32.5V29.9816H37C37.8 29.9816 38.56 29.6616 39.12 29.1016C39.68 28.5416 40 27.7816 40 26.9816V11.9816C40.04 10.7816 39.84 9.60156 39.4 8.48156C38.96 7.36156 38.3 6.36156 37.46 5.52156C36.62 4.68156 35.6 4.02156 34.5 3.58156C33.38 3.14156 32.2 2.94156 31 2.98156V3.00156ZM36.98 27.0016H32.48V6.14156C36.8 6.98156 36.98 11.4416 36.98 12.0016V27.0016Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.00159H11.5V20.3816H14.5V3.00159Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.98 3.00159H18.98V22.5016H7V3.00159H4V22.5016C4 24.1616 5.34 25.5016 7 25.5016H11.5V45.0016H14.5V25.5016H18.98C20.64 25.5016 21.98 24.1616 21.98 22.5016V3.00159Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForkKnifeTickets);
export default __webpack_public_path__ + "static/media/ic-fork-knife-tickets.526f14af6722c70f6c250bd698b9b955.svg";
export { ForwardRef as ReactComponent };